import { AssetThumbnail } from '@/components/asset-manager/components/asset-thumbnail';
import type { Asset } from '@/components/asset-manager/types';
import { getAssetDisplayName } from '@/components/asset-manager/utils';
import { SmallText } from '@/components/ui/typography';
import { cn } from '@/lib/utils';

interface ImageSelectorGridProps {
  assets: Asset[];
  selectedAssetId: string | null;
  onAssetClick: (asset: Asset) => void;
  onAssetDoubleClick?: (asset: Asset) => void;
  className?: string;
}

export function ImageSelectorGrid({
  assets,
  selectedAssetId,
  onAssetClick,
  onAssetDoubleClick,
  className,
}: ImageSelectorGridProps) {
  return (
    <div
      className={cn(
        'grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5',
        className,
      )}
    >
      {assets.map((asset) => (
        <button
          key={asset.id}
          type="button"
          onClick={() => onAssetClick(asset)}
          onDoubleClick={() => onAssetDoubleClick?.(asset)}
          className={cn('group relative flex min-w-0 flex-col gap-1 text-left rounded-lg')}
        >
          <AssetThumbnail
            asset={asset}
            size="md"
            className={cn(
              'rounded-lg',
              selectedAssetId === asset.id && 'ring-2 ring-primary bg-primary/10',
            )}
          />
          <SmallText className="w-full text-sm truncate px-1" title={getAssetDisplayName(asset)}>
            {getAssetDisplayName(asset)}
          </SmallText>
        </button>
      ))}
    </div>
  );
}
